import { Box, Container, Typography, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export function SolutionSection() {
  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: 'background.default' }}>
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          gap: { xs: 4, md: 8 },
        }}
      >
        <Box
          component="img"
          src="https://umsousercontent.com/lib_wfKJyoksALKsfAWv/735duoxtar45t195.png?w=1200&h=900&fit=max&dpr=2"
          alt="Solution Illustration"
          sx={{ flex: 1, maxWidth: { xs: '100%', md: 400 }, width: '100%' }}
        />
        <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
          <Typography variant="h4" gutterBottom>
            Simple & stress free solution
          </Typography>
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            spacing={{ xs: 2, md: 4 }}
            sx={{ mt: 3 }}
          >
            {['Move in Sooner', '$99 flat fee', 'No hidden or late fees'].map((text, idx) => (
              <Stack
                key={idx}
                direction="row"
                alignItems="center"
                spacing={1}
              >
                <CheckCircleIcon color="success" />
                <Typography>{text}</Typography>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}